import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';
import { GlobalFunctionsService } from '../services/global-functions.service';
import { LoginServiceServiceService } from '../services/login-service-service.service';
import { HotToastService } from '@ngneat/hot-toast';
import { HttpClient } from '@angular/common/http';
import { DemoService } from '../demo.service';

@Component({
  selector: 'app-login2-fa',
  templateUrl: './login2-fa.component.html',
  styleUrls: ['./login2-fa.component.scss']
})
export class Login2FAComponent implements OnInit {

  tfa: any = {};
  authcode: any = "";
  errorMessage: string = null;
  confirmPass: string = ""

  tfaFlag: boolean = false
  userObject = {
    uname: "",
    upass: "",
    authcode: ""
  }
  user_id: any;
  brand_id: any;
 
  access_level: any;
  user_password_expiry_date: any;
  user: any;
  tfa_result: any;
  tfa_result_confirm: any;


  constructor(
    private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    
    private authenticationService: AuthenticationService,
    public gfunc: GlobalFunctionsService,
    // private alertService: AlertService,
    // public toastr: HotToastService,
    vcr: ViewContainerRef,
    public toastr: HotToastService,
    public _loginService: LoginServiceServiceService,
    
  ) { 


    
    // this.tfaFlag = true;
    this.user_id = this.gfunc.sessionUserId;
    this.getUserById(this.user_id);
    // this.gfunc.setLoginSessionVars(); // just seeing if I need to set these to get the values




  }

  ngOnInit(): void {




    // this.getUserById(this.user_id);


    // This should hide the entire side menu
        //   const div = document.getElementById('side-menu');
        //  if(div) {
        //    div.style.display = 'none'
        //  }

        //  const header_div = document.getElementById('navbar-header');
        //  if(header_div) {
        //   header_div.style.display = 'none'
        //  }

 

  }
  




  getUserById(user_id) {

    this._demoService.getUsersById(user_id).subscribe(
       data => { this.user = data;
        this.brand_id = this.user.map(function(a) {return a ['brand_id']; });
        this.access_level = this.user.map(function(a) {return a ['access_level']; });
        this.user_password_expiry_date = this.user.map(function(a) {return a ['password_expiry_date']; });


             // get auth service details
              // this.getAuthDetails();
  
      },
       err =>{ 
        console.log('Could not get the user.');
        // this.user_password_date_status_expired = 1;
        // this.openModalWithComponent_PasswordExpired();
        
        console.error(err)},
       () => console.log(' Loaded User details correctly.')
     );
  }



// This now authenticates the Uuthcode
  loginUser() {
    this._loginService.loginAuth(this.userObject).subscribe((data) => {
      this.errorMessage = null;
      if (data.body['status'] === 200) {
        this._loginService.updateAuthStatus(true);
        // this.router.navigateByUrl('/admin/jobs/dashboard');
this.toastr.success("Code Accepted");

        this.router.navigateByUrl('/admin');
      }
      if (data.body['status'] === 206) {
        this.tfaFlag = true;
        this.toastr.error("Sorry, Your Code has not been accepted, try again. "  + this.tfaFlag);

      }
      if (data.body['status'] === 403) {
        this.errorMessage = data.body['message'];
        this.toastr.error(" "  + this.errorMessage );

      }
      if (data.body['status'] === 404) {
        this.errorMessage = data.body['message'];
        this.toastr.error(" "  + this.errorMessage );
      }
    })
  }





  getAuthDetails() {
    this._loginService.getAuth().subscribe((data) => {
      const result = data.body
      if (data['status'] === 200) {
        console.log(result);
                
                  this.toastr.warning('Retrived Your Auth Details')
                  console.log("Ret AuthDetails: " + JSON.stringify(data.body) )

                 
                  // Update the user details Database
                  // I think I need now to either update the user session variables or update the entire models...
                  this.tfa_result = result;
                  if(this.tfa_result){


                  // update_model[0].is_tfa_setup_passed = false
                    
                  let update_model = {
                    // ...data.body,
                    ...this.user,
                  }
                  update_model[0].tfa_secret = this.tfa_result.secret
                  update_model[0].tfa_tempSecret = this.tfa_result.tempSecret
                  update_model[0].tfa_dataURL = this.tfa_result.dataURL
                  update_model[0].tfa_tfaURL = this.tfa_result.tfaURL


                  if(this.gfunc.is_tfa_setup_passed != 1 && !this.gfunc.tfa_secret){
                  console.log("update Model: " + JSON.stringify(update_model));
                  this.toastr.success('Time now to Take a Photo of the QR code the Authenticator App')
                    this.updateBrandUser(update_model[0]);
                    
                  }
                  // this.toastr.success('Setup Result: Updated User Database');
                }// end if

        if (result == null) {
          this.setup();
        } else {
          this.tfa = result;






        }
      }
    });
  }

  setup() {
    this._loginService.setupAuth().subscribe((data) => {
      const result = data.body
      if (data['status'] === 200) {
        console.log(result);
        this.tfa = result;
      }
    });
  }

  confirm() {
    this._loginService.verifyAuth(this.authcode).subscribe((data) => {
      const result = data.body
      if (result['status'] === 200) {
        console.log(result);
        this.errorMessage = null;
        this.tfa.secret = this.tfa.tempSecret;
        this.tfa.tempSecret = "";



        // update the database again but setup ast trrue..
              this.tfa_result_confirm = result;
              if(this.tfa_result_confirm){


                
              let update_model = {
                // ...data.body,
                ...this.user,
              }
              update_model[0].is_tfa_setup_passed = 1
              update_model[0].tfa_secret = this.tfa.secret
              update_model[0].tfa_tempSecret = this.tfa.tempSecret
              update_model[0].tfa_dataURL = this.tfa.dataURL
              update_model[0].tfa_tfaURL = this.tfa.tfaURL

              console.log("update Model: " + JSON.stringify(update_model));

                this.updateBrandUser(update_model[0]); 

            }




      } else {
        this.errorMessage = result['message'];
      }
    });
  }

  disabledTfa() {
    this._loginService.deleteAuth().subscribe((data) => {
      const result = data.body
      if (data['status'] === 200) {
        console.log(result);
        this.authcode = "";
        this.getAuthDetails();
      }
    });
  }















  registerUser() {
    if (this.userObject.uname.trim() !== "" && this.userObject.upass.trim() !== "" && (this.userObject.upass.trim() === this.confirmPass))
      this._loginService.registerUser(this.userObject).subscribe((data) => {
        const result = data.body
        if (result['status'] === 200) {
          this.errorMessage = result['message'];
          this.toastr.success("Registered User");

  

          
        console.log("Rgister Return: " + JSON.stringify(data.body) );

        this.getAuthDetails();
       




          setTimeout(() => {
          this.router.navigate(['/admin']);
          }, 2000);
        }
      });
  }






  // update was here for onit but moved for onchange
updateBrandUser(model) {
  // model.email_signature_HTML_rendered = this.email_signature_HTML_rendered;
this._demoService.updateBrandUser(model).subscribe(
   data => {
    console.log(model);
     // this.trace_candidate_update = data;
          this.toastr.success('User Updated');
          //  this.gfunc.globalRouteViewSkipRoute("/admin") // redirect after update / register user for TFA
    // this.gfunc.setLoginSessionVars(); // just seeing if I need to set these to get the values


   // Subject to reload the manager component parent.
  // BrandUserManagerComponent.returned.next(false);
     return true;
   },
   error => {
     console.error('Error saving User!');
    return console.log(error);
   }
  // err => console.error(err),
  // () => console.log('done updates')
);
}



}
